import React from 'react';
import { Link } from 'react-router-dom';
import {
  HeadingText,
  ParagraphText,
  Button,
  StackLayout,
  StackItem,
} from '@leagueplatform/genesis-core';
import {
  usePageViewAnalytics,
  PRODUCT_AREA,
  trackAnalyticsEvent,
} from '@leagueplatform/analytics';
import { useIntl } from '@leagueplatform/locales';
import { BasePage } from 'components/base-page.component';
import HighFiveCelebrationIllustration from 'assets/high-five-celebration-illustration.png';
import { ROUTE_PATHS } from 'common/constants/constants';
import { ACCOUNT_SETUP_CONTENT_MAX_WIDTH } from 'common/constants/ui';
import { useIsBelowTablet } from 'hooks/use-is-below-tablet/use-is-below-tablet.hooks';
import { OnboardingMachineContext } from 'components/onboarding/onboarding.machine';
import { SCREEN_NAMES } from 'common/constants/analytics';

export const AccountSetupCompleteView = () => {
  const { send } = OnboardingMachineContext.useActorRef();
  const { formatMessage } = useIntl();
  const isBelowTablet = useIsBelowTablet();
  usePageViewAnalytics({
    product_area: PRODUCT_AREA.ONBOARDING,
    screen_name: SCREEN_NAMES.COMPLETE_ONBOARDING,
  });
  const handleContinue = () => send({ type: 'userSelectedContinue' });

  return (
    <BasePage
      showNavBar={false}
      css={{
        padding: isBelowTablet ? '$none' : '$four',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...(isBelowTablet && {
          '.wrapper': {
            height: '100%',
          },
        }),
      }}
    >
      <StackItem
        css={{
          background: '$surfaceCardSecondary',
          boxShadow: '$card',
          maxWidth: isBelowTablet ? '100%' : ACCOUNT_SETUP_CONTENT_MAX_WIDTH,
          height: isBelowTablet ? '100%' : 'fit-content',
          paddingBlock: isBelowTablet ? '$five' : '$twoAndHalf',
          paddingInline: isBelowTablet ? '$two' : '$five',
          gap: '$two',
        }}
        horizontalAlignment="center"
        verticalAlignment="center"
      >
        <img src={HighFiveCelebrationIllustration} aria-hidden="true" alt="" />
        <StackItem>
          <StackLayout spacing="$half" horizontalAlignment="center">
            <HeadingText level="1" size="lg">
              {formatMessage({ id: 'STR_ACCOUNT_SETUP_COMPLETE_HEADING' })}
            </HeadingText>
            <ParagraphText css={{ textAlign: 'center' }}>
              {formatMessage({ id: 'STR_ACCOUNT_SETUP_COMPLETE_BODY' })}
            </ParagraphText>
          </StackLayout>
        </StackItem>
        <StackItem css={{ width: '100%' }}>
          <StackLayout spacing="$oneAndHalf" horizontalAlignment="center">
            <Button
              as={Link}
              to={ROUTE_PATHS.HEALTH_ASSESSMENT}
              width="fillContainer"
              onClick={() => {
                trackAnalyticsEvent('button_clicked', {
                  product_area: PRODUCT_AREA.ONBOARDING,
                  screen_name: SCREEN_NAMES.COMPLETE_ONBOARDING,
                  detail: 'start health assessment',
                });

                handleContinue();
              }}
              textAlign="center"
            >
              {formatMessage({ id: 'STR_START_HEALTH_ASSESSMENT' })}
            </Button>
            <Button
              as={Link}
              to={ROUTE_PATHS.HOME}
              width="fillContainer"
              quiet
              priority="tertiary"
              onClick={() => {
                trackAnalyticsEvent('button_clicked', {
                  product_area: PRODUCT_AREA.ONBOARDING,
                  screen_name: SCREEN_NAMES.COMPLETE_ONBOARDING,
                  detail: 'skip health assessment',
                });
                handleContinue();
              }}
              // href={ROUTE_PATHS.HOME}
            >
              {formatMessage({ id: 'STR_NOT_NOW' })}
            </Button>
          </StackLayout>
        </StackItem>
      </StackItem>
    </BasePage>
  );
};
